export default "__VITE_ASSET__2ac566cf__"